// extracted by mini-css-extract-plugin
export var attribution = "_8h-4";
export var authorName = "_8h-5";
export var quote = "_8h-3";
export var testimonial = "_8h-2";
export var trustedBy = "_8h-0";
export var trustedByLabel = "_8h-1";